<template>
  <div>
    <div class="d-flex">
      <div class="configuration-section" :key="tableKey + 1">
        <div class="tables">
          <div class="table-section-title">ستون ها</div>
        </div>
        <div style="border-bottom: 2px solid #eff2f7; height: 300px; overflow-y: scroll" class="py-3">
          <draggable v-bind="dragOptions" :list="mainTableData.fields" class="list-group" ghost-class="ghost" handle=".handleTable">
            <div class="list-group-item d-flex justify-content-between align-items-center" v-for="(element, idx) in mainTableData.fields" :key="element.id">
              <div>
                <i style="color: #ced4da; cursor: grab" class="fa-solid fa-grid-horizontal fa-rotate-90 handleTable"></i>
                {{ element.title }}
              </div>
              <i
                :class="`fa-duotone fa-eye${element.show ? '' : '-slash'} addColBtn`"
                :style="!element.show && 'opacity:1 !important'"
                @click="toggleFieldToTable(element, idx)"
              ></i>
            </div>
          </draggable>
        </div>
        <div class="options">
          <div class="mt-3">
            <div class="d-flex align-items-center">
              <ToggleButton
                :value="searchable"
                @input="
                  hasSearch = $event
                  setToggleData()
                "
              />
              <div class="title-style">امکان جستجو</div>
            </div>
          </div>
          <div class="mt-3">
            <div class="d-flex align-items-center">
              <ToggleButton
                :value="addable"
                @input="
                  hasButton = $event
                  setToggleData()
                "
              />
              <div class="title-style">امکان اضافه کردن</div>
            </div>
            <div>
              <div v-if="hasButton">
                <div class="mb-2">
                  <div>نام دکمه</div>
                  <BaseText
                    @input="
                      tableTitle = $event
                      setToggleData()
                    "
                    :value="addButtonName"
                    placeholder="نام دکمه"
                  />
                </div>
                <div class="mb-2">
                  <div>کد دکمه</div>
                  <BaseText
                    @input="
                      tableCode = $event
                      setToggleData()
                    "
                    :value="buttonKey"
                    placeholder="کد دکمه"
                  />
                </div>
                <div>
                  <div>آدرس صفحه</div>
                  <BaseText
                    @input="
                      tableAddButtonLink = $event
                      setToggleData()
                    "
                    :value="addButtonLink"
                    placeholder="آدرس صفحه"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <div class="d-flex align-items-center">
              <ToggleButton
                :value="showAll"
                @input="
                  hasTotalCount = $event
                  setToggleData()
                "
              />
              <div class="title-style">نمایش تعداد کل</div>
            </div>
          </div>
          <div class="mt-3">
            <div class="d-flex align-items-center">
              <ToggleButton
                :value="downloadable"
                @input="
                  hasDownloadExcel = $event
                  setToggleData()
                "
              />
              <div class="title-style">دانلود اکسل</div>
            </div>
          </div>
          <div class="mt-3">
            <div class="d-flex align-items-center">
              <ToggleButton
                :value="sortable"
                @input="
                  hasSort = $event
                  setToggleData()
                "
              />
              <div class="title-style">مرتب سازی و جستجو</div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-section">
        <div class="mb-3">
          <div class="d-flex">
            <span @click.prevent.self="toggleInputTitle()" class="hoverInput" style="color:color: #444444; font-size: 14px" v-if="!showTitle">{{ titleInput }}</span>
            <div class="pen-class">
              <i class="fa-duotone fa-pencil" style="color: #a6a5a5"></i>
            </div>
          </div>
          <div class="d-flex" v-if="showTitle">
            <input autofocus class="title-input" @blur="toggleInputTitle()" v-model="titleInput" type="text" />
            <div class="pen-class">
              <i class="fa-duotone fa-pencil" style="color: #a6a5a5"></i>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr style="background: #f8f9fa">
                <template v-for="(item, idx) in mainTableData.fields">
                  <th @click.prevent.self="toggleInput(idx)" class="thWidth" :style="`width:${item.size}%`" :ref="`input${idx}`" v-if="item.show" :key="idx">
                    <span v-if="!item.showItem" @click.prevent.self="toggleInput(idx)"> {{ item.title }} </span>
                    <input
                      class="position-relative border-top-0 border-end-0 border-start-0 border-bottom-1 sizeInput"
                      v-if="item.showItem"
                      :ref="`input${idx}`"
                      type="text"
                      v-model="item.size"
                      autofocus
                      @blur="closeInput(idx)"
                      @keydown.enter="closeWithKeyboard(idx)"
                    />
                  </th>
                </template>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <Toast title="مجموع درصد وارد شده بیشتر از 100 می باشد" error :showToast="showToast" />
    </div>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import ToggleButton from '../../common/form/formModules/Checkbox.vue'
import draggable from 'vuedraggable'
import Toast from '../../common/Toast.vue'
// import Status from '../../common/Status.vue'
// import Audio from '../../common/Audio.vue'
// import Dropdown from '../../common/Dropdown.vue'
import { superAdminMixins } from '../../../utils/mixins'

export default {
  components: {
    BaseText,
    ToggleButton,
    draggable,
    Toast,
    // Status,
    // Audio,
    // Dropdown,
  },
  mixins: [superAdminMixins],
  data() {
    return {
      enabled: true,
      tableTitle: '',
      tableCode: '',
      tableAddButtonLink: '',
      hasSort: false,
      hasButton: false,
      hasSearch: false,
      hasCanban: false,
      hasDownloadExcel: false,
      hasTotalCount: false,
      showInput: false,
      showTitle: false,
      titleInput: 'تست',
      showToast: false,
      divWidth: [],
      tableKey: 1,
      widthSum: 0,
      returnOldValue: false,
      oldValue: 0,
      lists: [
        // {
        //   index: 16,
        //   order: 1,
        //   key: 'ImageUrl',
        //   label: '#',
        //   typeEnum: 8,
        //   type: 'Image',
        //   isCollection: false,
        //   size: 5,
        //   statusColors: [],
        // },
        // {
        //   index: 14,
        //   order: 2,
        //   key: 'Code',
        //   label: '\u0634\u0646\u0627\u0633\u0647',
        //   typeEnum: 0,
        //   type: 'Text',
        //   isCollection: false,
        //   size: 10,
        //   statusColors: [],
        // },
        // {
        //   index: 15,
        //   order: 3,
        //   key: 'Name',
        //   label: '\u0639\u0646\u0648\u0627\u0646 \u0645\u062D\u0635\u0648\u0644',
        //   typeEnum: 0,
        //   type: 'Text',
        //   isCollection: false,
        //   size: 35,
        //   statusColors: [],
        // },
        // {
        //   index: 34,
        //   order: 4,
        //   key: 'CategoryName',
        //   label: '\u062F\u0633\u062A\u0647 \u0628\u0646\u062F\u06CC',
        //   typeEnum: 0,
        //   type: 'Text',
        //   isCollection: false,
        //   size: 10,
        //   statusColors: [],
        // },
        // {
        //   index: 32,
        //   order: 5,
        //   key: 'TotalCount',
        //   label: '\u0645\u0648\u062C\u0648\u062F\u06CC',
        //   typeEnum: 0,
        //   type: 'Text',
        //   isCollection: false,
        //   size: 10,
        //   statusColors: [],
        // },
        // {
        //   index: 31,
        //   order: 6,
        //   key: 'MinPrice',
        //   label: '\u06A9\u0645\u062A\u0631\u06CC\u0646 \u0642\u06CC\u0645\u062A',
        //   typeEnum: 2,
        //   type: 'Price',
        //   isCollection: false,
        //   size: 10,
        //   statusColors: [],
        // },
        // {
        //   index: 30,
        //   order: 7,
        //   key: 'MaxPrice',
        //   label: '\u0628\u06CC\u0634\u062A\u0631\u06CC\u0646 \u0642\u06CC\u0645\u062A',
        //   typeEnum: 2,
        //   type: 'Price',
        //   isCollection: false,
        //   size: 10,
        //   statusColors: [],
        // },
        // {
        //   index: 22,
        //   order: 8,
        //   key: 'IsAvailable',
        //   label: '\u0648\u0636\u0639\u06CC\u062A',
        //   typeEnum: 7,
        //   type: 'Status',
        //   isCollection: false,
        //   size: 10,
        //   statusColors: [{}, {}],
        // },
      ],
      mainTableData: {
        id: 10,
        name: '\u0645\u062F\u06CC\u0631\u06CC\u062A \u0645\u062D\u0635\u0648\u0644\u0627\u062A',
        addRowPage: {
          key: 'product',
          title: '\u0645\u062D\u0635\u0648\u0644 \u062C\u062F\u06CC\u062F',
          link: 'product',
        },
        fields: [
          // {
          //   index: 16,
          //   order: 1,
          //   key: 'ImageUrl',
          //   label: '#',
          //   typeEnum: 8,
          //   type: 'Image',
          //   isCollection: false,
          //   size: 5,
          //   statusColors: [],
          // },
          // {
          //   index: 14,
          //   order: 2,
          //   key: 'Code',
          //   label: '\u0634\u0646\u0627\u0633\u0647',
          //   typeEnum: 0,
          //   type: 'Text',
          //   isCollection: false,
          //   size: 10,
          //   statusColors: [],
          // },
          // {
          //   index: 15,
          //   order: 3,
          //   key: 'Name',
          //   label: '\u0639\u0646\u0648\u0627\u0646 \u0645\u062D\u0635\u0648\u0644',
          //   typeEnum: 0,
          //   type: 'Text',
          //   isCollection: false,
          //   size: 35,
          //   statusColors: [],
          // },
          // {
          //   index: 34,
          //   order: 4,
          //   key: 'CategoryName',
          //   label: '\u062F\u0633\u062A\u0647 \u0628\u0646\u062F\u06CC',
          //   typeEnum: 0,
          //   type: 'Text',
          //   isCollection: false,
          //   size: 10,
          //   statusColors: [],
          // },
          // {
          //   index: 32,
          //   order: 5,
          //   key: 'TotalCount',
          //   label: '\u0645\u0648\u062C\u0648\u062F\u06CC',
          //   typeEnum: 0,
          //   type: 'Text',
          //   isCollection: false,
          //   size: 10,
          //   statusColors: [],
          // },
          // {
          //   index: 31,
          //   order: 6,
          //   key: 'MinPrice',
          //   label: '\u06A9\u0645\u062A\u0631\u06CC\u0646 \u0642\u06CC\u0645\u062A',
          //   typeEnum: 2,
          //   type: 'Price',
          //   isCollection: false,
          //   size: 10,
          //   statusColors: [],
          // },
          // {
          //   index: 30,
          //   order: 7,
          //   key: 'MaxPrice',
          //   label: '\u0628\u06CC\u0634\u062A\u0631\u06CC\u0646 \u0642\u06CC\u0645\u062A',
          //   typeEnum: 2,
          //   type: 'Price',
          //   isCollection: false,
          //   size: 10,
          //   statusColors: [],
          // },
          // {
          //   index: 22,
          //   order: 8,
          //   key: 'IsAvailable',
          //   label: '\u0648\u0636\u0639\u06CC\u062A',
          //   typeEnum: 7,
          //   type: 'Status',
          //   isCollection: false,
          //   size: 10,
          //   statusColors: [{}, {}],
          // },
        ],
        rows: [
          // {
          //   id: '43463E71-DCE3-4E1E-A88C-126C24871C0B',
          //   key: '43463E71-DCE3-4E1E-A88C-126C24871C0B',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://api.kookbaz.ir/filemanagement/AllFile/12264/2020/8/24/31911574186647.jpg',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '101',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value: '\u062C\u0627\u0645\u0627\u06CC\u0639 \u0648 \u0627\u0633\u06A9\u0627\u0686 \u0631\u0632\u06CC\u0646 \u067E\u0644\u06CC \u0627\u0633\u062A\u0631',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u0628\u0647\u062F\u0627\u0634\u062A \u0634\u062E\u0635\u06CC',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '0',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '50000',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '50000',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: '0A49A7C1-5500-4302-9938-637B886134F3',
          //   key: '0A49A7C1-5500-4302-9938-637B886134F3',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://api.kookbaz.ir/filemanagement/AllFile/12264/2020/6/27/87826295166632.jpg',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '17',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value: '\u0628\u0648\u06A9 \u0645\u0627\u0631\u06A9(\u0646\u0634\u0627\u0646\u06AF\u0631 \u06A9\u062A\u0627\u0628)',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u06A9\u062A\u0627\u0628',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '20',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '17',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '17',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u063A\u06CC\u0631 \u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(244,106,106)',
          //     },
          //   ],
          // },
          // {
          //   id: '8A12CD93-9513-437D-8905-B9D17AB7FE05',
          //   key: '8A12CD93-9513-437D-8905-B9D17AB7FE05',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/c8635d6e-5700-41a4-645b-08d99fa24261',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '109',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value:
          //         '\u067E\u0648\u062F\u0631\u0645\u0627\u0634\u06CC\u0646 \u0644\u0628\u0627\u0633\u0634\u0648\u06CC\u06CC \u0644\u0627\u0648\u0646\u062F\u0631 \u0627\u0646 \u067E\u06CC \u067E\u0631\u0633\u06CC\u0644 ',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u067E\u0648\u062F\u0631 \u0644\u0628\u0627\u0633 \u0634\u0648\u06CC\u06CC',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '5',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '126000.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '126000.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: 'BECFD29E-3839-49B9-A096-E311EA643A69',
          //   key: 'BECFD29E-3839-49B9-A096-E311EA643A69',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/5c8d88f0-1a25-41fb-755a-08d9a0e22872',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '108',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value: '\u0642\u0631\u0635 \u0633\u0641\u06CC\u062F\u06A9\u0646\u0646\u062F\u0647 \u0644\u0628\u0627\u0633 \u0646\u0627\u062A\u0627\u0631 ',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u067E\u0648\u062F\u0631 \u0644\u0628\u0627\u0633 \u0634\u0648\u06CC\u06CC',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '5',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '58900.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '58900.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: '60CF1309-CC93-48B6-B5D6-B2B142323464',
          //   key: '60CF1309-CC93-48B6-B5D6-B2B142323464',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/a135f119-bf5d-4e89-7559-08d9a0e22872',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '107',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value:
          //         '\u067E\u0648\u062F\u0631 \u0645\u0627\u0634\u06CC\u0646 \u0644\u0628\u0627\u0633\u0634\u0648\u06CC\u06CC \u0622\u0628 \u0633\u0631\u062F Poly Wash \u0627\u06A9\u062A\u06CC\u0648 ',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u067E\u0648\u062F\u0631 \u0644\u0628\u0627\u0633 \u0634\u0648\u06CC\u06CC',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '5',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '61300.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '61300.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: 'D70DDEA8-2325-4379-8C0E-5A485A1E92C1',
          //   key: 'D70DDEA8-2325-4379-8C0E-5A485A1E92C1',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/ca1921b8-6171-4af2-7558-08d9a0e22872',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '106',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value:
          //         '\u067E\u0648\u062F\u0631 \u0645\u0627\u0634\u06CC\u0646 \u0644\u0628\u0627\u0633\u0634\u0648\u06CC\u06CC \u062C\u0634\u0646\u0648\u0627\u0631\u0647 \u06AF\u0644 \u062A\u0633\u062A ',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u067E\u0648\u062F\u0631 \u0644\u0628\u0627\u0633 \u0634\u0648\u06CC\u06CC',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '5',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '60900.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '60900.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: 'C0B7ADED-8A82-4EC4-A89B-CC0007E60B60',
          //   key: 'C0B7ADED-8A82-4EC4-A89B-CC0007E60B60',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/4cbf7695-717a-4e22-7556-08d9a0e22872',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '105',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value:
          //         '\u067E\u0648\u062F\u0631 \u0645\u0627\u0634\u06CC\u0646 \u0644\u0628\u0627\u0633\u0634\u0648\u06CC\u06CC \u0628\u062F\u0648\u0646 \u0641\u0633\u0641\u0627\u062A \u0647\u0648\u0645 \u067E\u0644\u0627\u0633 ',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u067E\u0648\u062F\u0631 \u0644\u0628\u0627\u0633 \u0634\u0648\u06CC\u06CC',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '5',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '15750.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '15750.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: 'C9667373-FC78-42CF-BD3E-311F21EDFDD7',
          //   key: 'C9667373-FC78-42CF-BD3E-311F21EDFDD7',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/b29f30c9-5e7e-43cf-754f-08d9a0e22872',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '1010',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value: '\u0645\u0628\u0644 8 \u0646\u0641\u0631\u0647 \u0637\u0631\u062D \u0686\u0633\u062A\u0631 \u0622\u06CC\u062A\u0627\u06CC',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u0645\u0628\u0644',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '100',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '21000000',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '21000000',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: '1D1F220F-347D-42D8-BAD7-C295923F08E0',
          //   key: '1D1F220F-347D-42D8-BAD7-C295923F08E0',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/ec116167-a979-4c4b-7555-08d9a0e22872',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '104',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value:
          //         '\u067E\u0648\u062F\u0631 \u0645\u0627\u0634\u06CC\u0646 \u0644\u0628\u0627\u0633\u0634\u0648\u06CC\u06CC \u06F5 \u0622\u0646\u0632\u06CC\u0645 \u0633\u067E\u06CC\u062F',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u067E\u0648\u062F\u0631 \u0644\u0628\u0627\u0633 \u0634\u0648\u06CC\u06CC',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '5',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '15625.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '15625.00',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
          // {
          //   id: '06ECBB23-44DA-4C09-A87B-C587BD970F7F',
          //   key: '06ECBB23-44DA-4C09-A87B-C587BD970F7F',
          //   index: 0,
          //   items: [
          //     {
          //       fieldName: 'ImageUrl',
          //       value: 'https://apg.cloudware.ir/filemanager/api/file/files/dff37ef3-8e8a-4e6c-6458-08d99fa24261',
          //       size: 5,
          //       typeEnum: 8,
          //       type: 'Image',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Code',
          //       value: '23',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'Name',
          //       value: '\u0645\u0648\u062A\u0648\u0631\u0633\u06CC\u06A9\u0644\u062A \u067E\u0627\u0644\u0633 \u0645\u062F\u0644 RS200 \u0633\u0627\u0644 1400',
          //       size: 35,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'CategoryName',
          //       value: '\u0645\u0648\u062A\u0648\u0631 \u0633\u06CC\u06A9\u0644\u062A',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'TotalCount',
          //       value: '1',
          //       size: 10,
          //       typeEnum: 0,
          //       type: 'Text',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MinPrice',
          //       value: '99000000',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'MaxPrice',
          //       value: '99000000',
          //       size: 10,
          //       typeEnum: 2,
          //       type: 'Price',
          //       color: '',
          //     },
          //     {
          //       fieldName: 'IsAvailable',
          //       value: '\u0641\u0639\u0627\u0644',
          //       size: 10,
          //       typeEnum: 7,
          //       type: 'Status',
          //       color: 'rgb(52,195,143)',
          //     },
          //   ],
          // },
        ],
        filters: [],
      },
    }
  },
  computed: {
    draggingInfo() {
      return this.dragging ? 'under drag' : ''
    },
    dragOptions() {
      return {
        animation: 300,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
    calSize(item) {
      return this.mainTableData.fields[item].size
    },
  },
  methods: {
    setToggleData() {
      let temp = {
        addable: this.hasButton,
        searchable: this.hasSearch,
        downloadable: this.hasDownloadExcel,
        sortable: this.hasSort,
        showAll: this.hasTotalCount,
        teamtaskName: this.titleInput,
        buttonLink: this.tableAddButtonLink,
        buttonKey: this.tableCode,
        buttonName: this.tableTitle,
      }
      this.setInitialData(temp)
    },
    toggleFieldToTable(payload, idx) {
      this.mainTableData.fields[idx].show = payload.show
      this.lists[idx].show = !this.lists[idx].show

      // for (let i = 0; i < this.mainTableData.rows.length; i++) {
      //   this.mainTableData.rows[i].items.find((item) => item.fieldName == payload.key).show = !this.mainTableData.rows[i].items.find((item) => item.fieldName == payload.key).show
      //   if (i == this.mainTableData.rows.length - 1) {
      //     }
      // }
      // #TODO  fix rows when get it in getdata
      // this.tableKey += 1
    },
    toggleInput(payload) {
      let inp = 'input' + payload
      this.oldValue = this.mainTableData.fields[payload].size
      this.mainTableData.fields[payload].showItem = true
      this.tableKey += 1
      setTimeout(() => {
        this.$refs[inp][0].focus()
      }, 50)
    },
    closeInput(payload) {
      if (this.returnOldValue) {
        this.mainTableData.fields[payload].size = this.oldValue
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
        }, 1500)
      }
      this.mainTableData.fields[payload].showItem = false
      this.tableKey += 1
    },
    closeWithKeyboard(payload) {
      if (this.returnOldValue) {
        this.closeInput(payload)
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
        }, 1500)
        return
      }
      this.closeInput(payload)
      // if(payload < 4) {
      // let newPayload = payload == 3 ? payload : payload+1
      this.toggleInput(payload + 1)
      // }
      // 5 = length
    },
    toggleInputTitle() {
      this.showTitle = !this.showTitle
    },
    setInitialToggleData() {
      this.hasButton = this.addable
      this.hasSort = this.sortable
      this.hasTotalCount = this.showAll
      this.hasSearch = this.searchable
      this.hasDownloadExcel = this.downloadable
      this.titleInput = this.tableName
      this.tableAddButtonLink = this.addButtonLink
      this.tableTitle = this.addButtonName
      this.tableCode = this.buttonKey
    },
  },
  watch: {
    mainTableData: {
      deep: true,
      handler() {
        this.widthSum = 0
        this.returnOldValue = false
        for (let i = 0; i < this.mainTableData.fields.length; i++) {
          this.widthSum += Number(this.mainTableData.fields[i].size)
        }
        if (this.widthSum > 100) {
          this.returnOldValue = true
        }
      },
    },
  },
  mounted() {
    let tableColumns = JSON.parse(JSON.stringify(this.tableColumns))
    this.mainTableData.fields = tableColumns
    this.lists = tableColumns
    this.setInitialToggleData()
    this.tableKey += 1
  },
  beforeDestroy() {
    this.setTableColumns(this.lists)
  },
}
</script>

<style scoped lang="scss">
::v-deep .alert-popUp {
  bottom: 10px;
  right: 670px;
}
::v-deep .switch input[type='checkbox']:checked + label {
  background: #556ee6;
}
::v-deep .switch label {
  width: 47px;
  height: 20px;
}
::v-deep .switch label::after {
  top: 2px;
  left: 2px;
}
.hoverInput:hover {
  padding: 5px;
  width: 180px;
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  outline: none;
  height: 33px;
  border-radius: 0 4px 4px 0;
}
.hoverInput:hover + .pen-class {
  display: flex;
}
.configuration-section {
  padding: 30px 15px;
  background: white;
  border-radius: 6px;
  width: 30%;
}
.options {
  height: 215px;
  overflow-y: scroll;
}
.table-section {
  padding: 20px 10px 0 10px;
  width: 70%;
  border-right: 2px solid #eff2f7;
  background: white;
}
.table-section-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: right;
  text-transform: uppercase;
  color: #495057;
}

.list-group-item {
  background: rgba(206, 212, 218, 0.16);
  border-radius: 4px;
  margin: 3px 0;
}
.title-style {
  min-width: 140px;
  max-width: 140px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}
.title-input {
  padding: 5px;
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  outline: none;
  height: 33px;
  border-radius: 0 4px 4px 0;
}
.title-input:focus {
  outline: none;
}
.title-input + .pen-class {
  display: flex;
}
.pen-class {
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(206, 212, 218, 0.28);
  border: 1px solid #ced4da;
  border-right: 0;
  box-sizing: border-box;
  width: 33px;
  height: 33px;
  border-radius: 4px 0 0 4px;
}
.tables {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-column {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.aprove {
  background-color: #556ee6 !important;
  padding: 10px 20px !important;
  margin: 0 !important;
}
.btn-border {
  border-radius: 4px !important;
}
//////////////////////////////////////////
.thWidth {
  min-width: 60px !important;
  transition: width 2s !important;
  padding: 10px 5px;
  align-items: center;
  justify-content: space-between;
}
.sizeInput {
  border: 0 !important;
  border-bottom: 1px solid #ccc !important;
  width: 30px;
  text-align: center;
  direction: ltr;
  font-size: 16px;
  outline: none !important;
  background: transparent;
}
.ellipsis {
  position: relative;
}
.ellipsis:before {
  content: '&nbsp;';
  visibility: hidden;
}
.ellipsis span,
.ellipsis div {
  position: absolute;
  left: 0px;
  right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ellipsis div .productImg,
.ellipsis div .userImg {
  top: 5px;
}
.productImg {
  border-radius: 4px !important;
  width: 45px;
  height: 37px;
}
.userImg {
  border-radius: 50% !important;
  width: 32px;
  height: 32px;
}
.userPic {
  font-size: 45px;
  color: #556ee6;
}
.customHR {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  max-width: 50px;
}
.dLTR {
  direction: ltr !important;
}
.colorDiv {
  width: 12px;
  height: 12px;
  border-radius: 1px;
  position: relative !important;
}
.fileStyle {
  font-size: 23px;
  font-weight: 100;
}
i.fa-regular.fa-times.float-end {
  cursor: pointer;
}
i.addColBtn {
  cursor: pointer;
  opacity: 0;
}
.list-group-item:hover .addColBtn {
  opacity: 1;
}
</style>
